// stores/index.ts
import dayjs from "dayjs";
import { defineStore } from "pinia";
import lifeVip from "~/assets/images/ai/life-vip.svg";
import enterpriseExpired from "~/assets/images/ai/vip/enterprise-expired.svg";
import enterpriseVip from "~/assets/images/ai/vip/enterprise-vip.svg";
import svipExpired from "~/assets/images/ai/vip/svip-expired.svg";
import svip from "~/assets/images/ai/vip/svip.svg";
import tvipGeneral from "~/assets/images/ai/vip/tvip-general.svg";
import vipExpired from "~/assets/images/ai/vip/vip-expired.svg";
// import vipGeneral from "~/assets/images/ai/vip/vip-general.svg";
import vip from "~/assets/images/ai/vip/vip.svg";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "~/enum/cache/cookie";
import Cookie from "~/utils/cookie";

let timer: NodeJS.Timeout;

// 创建 store - 使用对象式API
export const useMainStore = defineStore("main", {
  // 状态
  // 之前都是写的any，一下没办法全部抽出来
  state: () => ({
    login: false,
    token: "",
    refreshToken: "",
    name: "",
    welcome: "",
    title: "", //职位
    avatar: "", //当前用户头像
    workUnit: "", //当前企业名称
    role: "", //角色
    permission: [] as any[], //当前用户权限
    userType: "", //用户类型（lawyer：机构版，person：个人版，team：团队版）
    corpList: [] as any[], //当前用户所属企业列表
    accountBind: {} as Record<string, any>, //账号绑定状态
    expireProduct: {} as Record<string, any>, //产品到期状态
    info: {} as Record<string, any>,
    departments: [] as any[],
    currentCorpInfo: {} as Record<string, any>, //当前的组织信息
    clock: null as any,
    region: [] as any[],
    companyType: [] as any[],
    industry: [] as any[],
    roleUser: {} as Record<string, any[]>,
    dingRole: [] as any[], //当前企业原始角色数据
    nowTime: Date.now(),
    //通知提醒数量
    notice: {
      tudoCount: 0,
      noticeCount: 0,
    },
    isIframe: false, //当前页面是不是iframe页面
    windowTotal: 0, // 当前窗口的数量
    bc: null as any,
    iframeBc: null as any,
    versionType: 1, // 1是专业版 2是企业版
    showPayment: false, // 是否显示支付弹窗
    showDLUpgrade: false, // 是否显示下载升级弹窗
  }),

  // getters
  getters: {
    getName: (state) => state.name,
    personCorpId: (state) => {
      const person = state.corpList.find((item: any) => item.corpType === "person") as any;
      return person ? person.corpId : false;
    },
    // 专业版：终身会员、企业会员、svip会员、vip会员、试用会员
    // 企业版：企业会员、终身会员、svip会员、vip会员、试用会员
    vipIcon: (state) => {
      if (state.versionType === 1) {
        if (state.expireProduct?.permanentLicense) {
          return lifeVip;
        } else if (state.expireProduct?.cvipStatus === 1) {
          return enterpriseVip;
        } else if (state.expireProduct?.svipStatus === 1) {
          return svip;
        } else if (state.expireProduct?.vipStatus === 1) {
          return vip;
        } else if (state.expireProduct?.tvipStatus === 1) {
          return tvipGeneral;
        } else if (state.expireProduct?.cvipStatus === 2) {
          return enterpriseExpired;
        } else if (state.expireProduct?.svipStatus === 2) {
          return svipExpired;
        } else if (state.expireProduct?.vipStatus === 2) {
          return vipExpired;
        } else {
          return "";
        }
      } else {
        if (state.expireProduct?.cvipStatus === 1) {
          return enterpriseVip;
        } else if (state.expireProduct?.permanentLicense) {
          return lifeVip;
        } else if (state.expireProduct?.svipStatus === 1) {
          return svip;
        } else if (state.expireProduct?.vipStatus === 1) {
          return vip;
        } else if (state.expireProduct?.tvipStatus === 1) {
          return tvipGeneral;
        } else if (state.expireProduct?.cvipStatus === 2) {
          return enterpriseExpired;
        } else if (state.expireProduct?.svipStatus === 2) {
          return svipExpired;
        } else if (state.expireProduct?.vipStatus === 2) {
          return vipExpired;
        } else {
          return "";
        }
      }
    },
    vipText: (state) => {
      if (state.versionType === 1) {
        if (state.expireProduct?.permanentLicense) {
          return `尊敬的终身会员，您好`;
        } else if (state.expireProduct?.cvipStatus === 1) {
          return `得理法搜企业会员：\n${state.expireProduct.cExpireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.svipStatus === 1) {
          return `得理法搜SVIP：\n${state.expireProduct.sExpireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.vipStatus === 1) {
          return `得理法搜VIP：\n${state.expireProduct.expireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.tvipStatus === 1) {
          return `得理法搜试用会员：${state.expireProduct.expireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.cvipStatus === 2) {
          return `得理法搜企业会员：\n已到期${dayjs().diff(dayjs(state.expireProduct.expireDate), "day")}天`;
        } else if (state.expireProduct?.svipStatus === 2) {
          return `得理法搜SVIP：\n已到期${dayjs().diff(dayjs(state.expireProduct.expireDate), "day")}天`;
        } else if (state.expireProduct?.vipStatus === 2) {
          return `得理法搜VIP：\n已到期${dayjs().diff(dayjs(state.expireProduct.expireDate), "day")}天`;
        } else {
          return "暂未开通会员";
        }
      } else {
        if (state.expireProduct?.cvipStatus === 1) {
          return `得理法搜企业会员：\n${state.expireProduct.cExpireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.permanentLicense) {
          return `尊敬的终身会员，您好`;
        } else if (state.expireProduct?.svipStatus === 1) {
          return `得理法搜SVIP：\n${state.expireProduct.sExpireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.vipStatus === 1) {
          return `得理法搜VIP：\n${state.expireProduct.expireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.tvipStatus === 1) {
          return `得理法搜试用会员：${state.expireProduct.expireDate.split(" ")[0]}到期`;
        } else if (state.expireProduct?.cvipStatus === 2) {
          return `得理法搜企业会员：\n已到期${dayjs().diff(dayjs(state.expireProduct.expireDate), "day")}天`;
        } else if (state.expireProduct?.svipStatus === 2) {
          return `得理法搜SVIP：\n已到期${dayjs().diff(dayjs(state.expireProduct.expireDate), "day")}天`;
        } else if (state.expireProduct?.vipStatus === 2) {
          return `得理法搜VIP：\n已到期${dayjs().diff(dayjs(state.expireProduct.expireDate), "day")}天`;
        } else {
          return "暂未开通会员";
        }
      }
    },
  },

  // actions
  actions: {
    // 设置 token
    setToken(tokenValue: string) {
      this.token = tokenValue;
      Cookie.set(ACCESS_TOKEN, tokenValue, 7);
    },

    // 设置刷新 token
    setRefreshToken(refreshTokenValue: string) {
      this.refreshToken = refreshTokenValue;
      Cookie.set(REFRESH_TOKEN, refreshTokenValue, 30);
    },

    // 设置名称和工作单位
    setName({ name, workUnit }: { name: string; workUnit: string }) {
      this.name = name;
      this.workUnit = workUnit;
    },

    // 设置头像
    setAvatar(avatarValue: string) {
      this.avatar = avatarValue;
    },

    // 设置角色
    setRole(roleValue: string) {
      this.role = roleValue;
    },

    // 设置用户类型
    setUserType(userTypeValue: string) {
      this.userType = userTypeValue;
    },

    // 设置职位
    setTitle(titleValue: string) {
      this.title = titleValue;
    },

    // 设置权限
    setPermission(permissionValue: any[]) {
      this.permission = permissionValue;
    },

    // 设置用户信息
    setInfo(infoValue: Record<string, any>) {
      this.info = infoValue;
    },

    // 设置部门
    setDepartments(departmentsValue: any[]) {
      this.departments = departmentsValue;
    },

    // 设置时钟
    setClock(clockValue: any) {
      this.clock = clockValue;
    },

    // 设置当前时间
    setNowTime(nowTimeValue: number) {
      this.nowTime = nowTimeValue;
    },

    // 设置区域
    setRegion(regionValue: any[]) {
      this.region = regionValue;
    },

    // 设置公司类型
    setCompanyType(companyTypeValue: any[]) {
      this.companyType = companyTypeValue;
    },

    // 设置行业
    setIndustry(industryValue: any[]) {
      this.industry = industryValue;
    },

    // 设置角色用户
    setRoleUser({ type, list }: { type: string; list: any[] }) {
      this.roleUser[type] = list;
    },

    // 设置登录状态
    setLogin(flag: boolean) {
      this.login = flag;
    },

    // 设置企业列表
    setCorpList(corpListValue: any[]) {
      this.corpList = corpListValue;
    },

    // 设置钉钉角色
    setDingRole(list: any[]) {
      this.dingRole = list;
    },

    // 设置账号绑定
    setAccountBind(value: Record<string, any>) {
      this.accountBind = value;
    },

    // 设置当前企业信息
    setCurrentCorpInfo(value: Record<string, any>) {
      this.currentCorpInfo = value;
    },

    // 设置通知
    setNotice(value: { tudoCount: number; noticeCount: number }) {
      this.notice = value;
    },

    // 设置过期产品
    setExpireProduct(value: Record<string, any>) {
      this.expireProduct = value;
    },

    // 设置是否是 iframe
    setIsIframe(isIframeValue: boolean) {
      this.isIframe = isIframeValue;
    },

    // 设置窗口总数
    setWindowTotal(windowTotalValue: number) {
      this.windowTotal = windowTotalValue;
    },

    // 设置 BC
    setBC(bcValue: any) {
      this.bc = bcValue;
    },

    // 设置 iframe BC
    setIframeBC(bcValue: any) {
      this.iframeBc = bcValue;
    },

    // 更新用户信息 - 遵循 Pinia 最佳实践，只负责状态更新
    updateUserInfo(userInfo: Record<string, any>) {
      const { nowTime } = userInfo;

      // 更新用户基本信息
      this.setInfo(userInfo);
      this.versionType = userInfo.versionType;
      this.setName({
        name: userInfo.name || "",
        workUnit: userInfo.workUnit || "",
      });
      this.setAvatar(userInfo.avatar || "");
      this.setCorpList(userInfo.dlsCorpList || []);

      // 更新过期产品信息
      if (userInfo.expireProduct) {
        this.setExpireProduct(userInfo.expireProduct);
      }

      // 设置登录状态
      this.setLogin(true);
      this.setToken(Cookie.get(ACCESS_TOKEN) || "");

      // 更新服务器时间
      if (nowTime) {
        this.setNowTime(nowTime);
      }

      // orlando标注：没搞懂为什么原代码，启动timer，要和用户信息耦合起来
      // 保留和旧代码逻辑一致
      this.startTimeTimer();
    },

    // 启动时间计时器
    startTimeTimer() {
      // 清除旧的计时器
      clearInterval(timer);
      // 设置新的计时器
      timer = setInterval(() => {
        this.nowTime += 1000;
      }, 1000);
    },

    // 停止时间计时器
    stopTimeTimer() {
      clearInterval(timer);
    },

    // 迁移出了useUserInfo，后续所有调用这个函数的地方，全部都要换成useUserInfo
    async getInfo(params: { refresh?: boolean; type?: string } = {}) {
      console.warn(
        "store.getInfo() 已废弃，请使用 useUserInfo() composable 代替。" + "这样更符合 Vue 3 + Pinia 最佳实践。",
      );

      // 为了向后兼容，保留这个方法，但建议迁移到 useUserInfo
      if (!Cookie.get(ACCESS_TOKEN)) {
        await this.logout();
        return;
      }

      // 如果已登录且不需要刷新，直接返回缓存信息
      if (this.login && !params.refresh) {
        return this.info;
      }

      // 对于新代码，应该使用 useUserInfo composable
      return this.info;
    },

    // 登出
    async logout() {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          this.setName({ name: "", workUnit: "" });
          this.setInfo({});
          this.setAvatar("");
        }, 500);
        this.setToken("");
        this.setRefreshToken("");
        this.setLogin(false); //设为未登录
        Cookie.remove(ACCESS_TOKEN);
        Cookie.remove(REFRESH_TOKEN);
        this.stopTimeTimer(); // 使用新的停止计时器方法
        resolve();
      });
    },

    // 设置是否显示支付弹窗
    setShowPayment(showPaymentValue: boolean) {
      this.showPayment = showPaymentValue;
    },

    // 设置是否显示升级弹窗
    setDLUpgrade(showUpgradeValue: boolean) {
      this.showDLUpgrade = showUpgradeValue;
    },

    //判断是否具有下载权限
    hasDownloadPermission() {
      if (this.expireProduct?.downloadLicense) {
        return true;
      } else {
        this.showDLUpgrade = true;
        return false;
      }
    },
  },
});
